import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/earningsCalculator";
import EarningsCalculatorIncomeBreakdown from "../EarningsCalculatorIncomeBreakdown/EarningsCalculatorIncomeBreakdown";
import { LeafCollapsibleSection } from "../../../common/leaf/LeafCollapsibleSection/LeafCollapsibleSection";
import "./EarningsCalculatorDashboard.scss";
import {
  hideBonusDetailsTrack,
  showBonusDetailsTrack,
} from "../../../common/tealium/EarningCalculator/EarningCalculatorTrack";
import { useAppSelector } from "../../../store";
import LeafRectangleLoader from "../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";

type Props = {
  isFetching: boolean;
  isCSIActive: boolean;
  isBFIActive: boolean;
  isBBIActive: boolean;
};

const EarningsCalculatorDashbaord = (props: Props) => {
  const { t } = useTranslation(["earningsCalculator"]);
  const { isFetching, isCSIActive, isBFIActive, isBBIActive } = props;

  const { ECComputedData } = useAppSelector((state: any) => state.earningCalculator);
  const { EarningSummary } = ECComputedData;
  const { PersonalPV, PersonalBV, GroupPV, PerfBonusLevel, Earnings } = EarningSummary;

  const onCollapseClick = (isExpanded: boolean) => {
    isExpanded === true ? showBonusDetailsTrack() : hideBonusDetailsTrack();
  };

  const Loader = ({ value }: { value: string }) => (
    <LeafRectangleLoader height="1.75rem" width="80%" isLoading={isFetching}>
      {value}
    </LeafRectangleLoader>
  );

  return (
    <div className="earnings-calculator-dashboard">
      <div className="earnings-calculator-dashboard__content">
        <div className="earnings-calculator-dashboard__metric">
          <span className="earnings-calculator-dashboard__metric-text">{`${t(
            "keyMetrics.personalPv",
            defaultContent["keyMetrics"]["personalPv"],
          )}`}</span>
          <span className="earnings-calculator-dashboard__metric-value">
            <Loader value={PersonalPV.Formatted} />
          </span>
        </div>
        <div className="earnings-calculator-dashboard__metric">
          <span className="earnings-calculator-dashboard__metric-text">{`${t(
            "keyMetrics.personalBv",
            defaultContent["keyMetrics"]["personalBv"],
          )}`}</span>
          <span className="earnings-calculator-dashboard__metric-value">
            <Loader value={PersonalBV.Formatted} />
          </span>
        </div>
        <div className="earnings-calculator-dashboard__metric">
          <span className="earnings-calculator-dashboard__metric-text">{`${t(
            "keyMetrics.totalGroupPv",
            defaultContent["keyMetrics"]["totalGroupPv"],
          )}`}</span>
          <span className="earnings-calculator-dashboard__metric-value">
            <Loader value={GroupPV.Formatted} />
          </span>
        </div>
        <div className="earnings-calculator-dashboard__metric">
          <span className="earnings-calculator-dashboard__metric-text">{`${t(
            "keyMetrics.performanceBonusLevel",
            defaultContent["keyMetrics"]["performanceBonusLevel"],
          )}`}</span>
          <span className="earnings-calculator-dashboard__metric-value">
            <Loader value={PerfBonusLevel.Formatted} />
          </span>
        </div>
        <div className="earnings-calculator-dashboard__metric">
          <span className="earnings-calculator-dashboard__metric-text">{`${t(
            "dashboardTile.simulatedEarnings",
            defaultContent["dashboardTile"]["simulatedEarnings"],
          )}`}</span>
          <span className="earnings-calculator-dashboard__simulated-earnings">
            <Loader value={Earnings.Formatted} />
          </span>
        </div>
      </div>
      <LeafCollapsibleSection
        closeButtonPosition={"bottom"}
        titleExpand={`${t("dashboardTile.seeBonusDetails", defaultContent["dashboardTile"]["seeBonusDetails"])}`}
        titleCollapse={`${t("incomeBreakdownTile.close", defaultContent["incomeBreakdownTile"]["close"])}`}
        onClickFn={onCollapseClick}
      >
        <EarningsCalculatorIncomeBreakdown
          isLoading={isFetching}
          ActiveStatus={{
            IsCSIActive: isCSIActive,
            IsBFIActive: isBFIActive,
            IsBBIActive: isBBIActive,
          }}
        />
      </LeafCollapsibleSection>
    </div>
  );
};

export default EarningsCalculatorDashbaord;
